import React from 'react';

function NameField({ value, onChange, disabled, error }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "0px",
        maxWidth: "100%",
      }}
    >
      <label
        htmlFor="myname"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
      
      <select
  name="selection1"
  value={value.selection1}
  onChange={onChange}
  style={{
    flex: "1",
    minWidth: "50px",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #ff80ab",
    fontSize: "1rem",
    background: "linear-gradient(135deg, #ffe4e1, #ffc1e3)", // Keeps custom background
    color: "#ff007f", // Pink font color
    // ❌ Removed: appearance: "none", WebkitAppearance, MozAppearance
    boxShadow: "0px 4px 8px rgba(255, 192, 203, 0.4)",
    transition: "background-color 0.3s ease",
    cursor: "pointer"
  }}
>
  <option value="Name">Name</option>
  <option value="Student">Student</option>
  {/*<option value="Std. Name">Std. Name</option>*/}
</select>


        <input
          type="text"
          name="name1"
          value={value.name1}
          onChange={onChange}
		  disabled={disabled}
          placeholder="Ex: A.P.J. Abdul Kalam"
          style={{
            flex: "2",
            minWidth: "100px",
            padding: "10px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            fontSize: "1rem",
            boxSizing: "border-box",
          }}
        />
      </label>

      {error && <div style={{ color: "red", fontSize: "12px" }}>{error}</div>}
    </div>
  );
}

export default NameField;
